// Minimal critical JS for Bootstrap layout
(function () {
  'use strict';

  // Simple Cookies polyfill if js-cookie is not available
  if (typeof Cookies === 'undefined') {
    window.Cookies = {
      get: function (name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      },
      set: function (name, value, options) {
        let cookie = `${name}=${value}`;
        if (options && options.expires) {
          const date = new Date();
          date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
          cookie += `; expires=${date.toUTCString()}`;
        }
        if (options && options.path) {
          cookie += `; path=${options.path}`;
        }
        document.cookie = cookie;
      },
    };
  }

  // Define FAB object immediately with all necessary methods
  window.FAB = {
    showMessage: function (params) {
      // Bootstrap-compatible message display
      var defaults = {
        position: 'centered',
        type: 'success',
        delay: 4,
      };
      var options = { ...defaults, ...params };

      // Create Bootstrap alert
      var alertClass =
        options.type === 'error'
          ? 'alert-danger'
          : options.type === 'info'
          ? 'alert-info'
          : options.type === 'warning'
          ? 'alert-warning'
          : 'alert-success';

      var alertHtml = `
        <div class="alert ${alertClass} alert-dismissible fade show" role="alert">
          ${options.message || 'Default message'}
          <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
      `;

      // Show alert (you can customize this based on your needs)
      if (options.position === 'centered') {
        // Create modal for centered messages
        var modalHtml = `
          <div class="modal fade" id="fabMessageModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-body">
                  ${alertHtml}
                </div>
              </div>
            </div>
          </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        var modal = new bootstrap.Modal(
          document.getElementById('fabMessageModal')
        );
        modal.show();

        // Auto-hide after delay
        setTimeout(() => {
          modal.hide();
          document.getElementById('fabMessageModal').remove();
        }, options.delay * 1000);
      } else {
        // Show as toast or inline
        console.log(options.message);
      }
    },

    showSuccess: function (message) {
      this.showMessage({ message, type: 'success' });
    },

    showInfo: function (message) {
      this.showMessage({ message, type: 'info' });
    },

    showError: function (message) {
      this.showMessage({ message, type: 'error' });
    },

    docReady: function (fn) {
      if (
        document.readyState === 'complete' ||
        document.readyState === 'interactive'
      ) {
        setTimeout(fn, 1);
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    },

    setRole: function (role) {
      // Set role in localStorage or cookie
      if (typeof Cookies !== 'undefined') {
        Cookies.set('role', role);
      } else {
        localStorage.setItem('role', role);
      }
    },

    auth0Login: function (role, connection) {
      // Set role first
      this.setRole(role);

      // Auth0 login logic
      if (typeof webAuth !== 'undefined') {
        webAuth.authorize({ connection: connection });
      } else {
        console.error('Auth0 not loaded');
      }
    },

    setProduct: function (product) {
      if (typeof Cookies !== 'undefined') {
        Cookies.set('product', product);
      } else {
        localStorage.setItem('product', product);
      }
    },

    fireGtmEvent: function (event) {
      if (window.dataLayer) {
        window.dataLayer.push(event);
      }
    },

    trackJoinClick: function (source) {
      this.fireGtmEvent({
        event: 'join_click',
        source,
      });
    },

    trackLoginClick: function (source) {
      this.fireGtmEvent({
        event: 'login_click',
        source,
      });
    },

    showOverlays: function (divIds) {
      FAB.body_overflow =
        document.querySelector('body').style.overflow || 'auto';
      document.querySelector('body').style.overflow = 'hidden';
      FAB.scrollPosition = window.pageYOffset;

      var classesToCheck = ['is-hidden-mobile', 'is-shown-mobile', 'is-hidden'];
      for (var j = 0; j < divIds.length; j++) {
        var divId = divIds[j];
        for (var i = 0; i < classesToCheck.length; i++) {
          var div = document.getElementById(divId);
          if (div) {
            var classToCheck = classesToCheck[i];
            if (div.classList.contains(classToCheck)) {
              if (!FAB.hasOwnProperty('previousClasses')) {
                FAB.previousClasses = {};
              }
              FAB.previousClasses[divId] = classToCheck;
              div.classList.remove(classToCheck);
            }
          }
        }
      }

      document.querySelector('body').style.position = 'fixed';
      setTimeout(function () {
        document.querySelector('body').style.position = 'static';
      }, 100);
    },

    hideOverlays: function (divIds) {
      document.querySelector('body').style.overflow = FAB.body_overflow;
      document.querySelector('body').style.position = 'static';
      window.scrollTo(0, FAB.scrollPosition);

      for (var i = 0; i < divIds.length; i++) {
        var divId = divIds[i];
        var div = document.getElementById(divId);
        if (div && FAB.previousClasses && FAB.previousClasses[divId]) {
          div.classList.add(FAB.previousClasses[divId]);
        }
      }
      return false;
    },
  };

  // Ensure FAB is available immediately
  if (typeof window !== 'undefined') {
    window.FAB = window.FAB || {};
  }
})();
